/* =========================================================
   CUSTOM MEASUREMENTS (CMX) — AlbinaDyla / Basel theme
   - Properties disabled by default (Standard mode)
   - Enabled only when Custom mode is selected
   - Mandatory: closing popup incomplete reverts to Standard
   - Intercepts main ATC button if Custom + incomplete
   ========================================================= */

(function () {
  const root = document.querySelector('[data-cmx]');
  if (!root) return;

  const modal = root.querySelector('[data-cmx-modal]');
  if (!modal) return;

  const orderTypeProp = root.querySelector('[data-cmx-prop="orderType"]');
  const unitProp      = root.querySelector('[data-cmx-prop="unit"]');
  const propInputs    = root.querySelectorAll('input[name^="properties"]');
  const noticeEl      = root.querySelector('[data-cmx-notice]');

  const tabs = root.querySelectorAll('[data-cmx-mode]');

  /* Move modal to body (fixes theme stacking issues) */
  if (modal.parentElement !== document.body) {
    document.body.appendChild(modal);
  }

  const closeBtns    = modal.querySelectorAll('[data-cmx-close]');
  const inputs       = modal.querySelectorAll('[data-cmx-input]');
  const addBtn       = modal.querySelector('[data-cmx-add]');
  const alertBox     = modal.querySelector('[data-cmx-alert]');
  const modalWarnEl  = modal.querySelector('[data-cmx-modal-warn]');

  const qtyInput  = modal.querySelector('[data-cmx-qty]');
  const minusBtn  = modal.querySelector('[data-cmx-minus]');
  const plusBtn   = modal.querySelector('[data-cmx-plus]');
  const unitBtns  = modal.querySelectorAll('[data-cmx-unit]');
  const figUnits  = modal.querySelectorAll('[data-cmx-figunit]');
  const figValues = (key) => modal.querySelector(`[data-cmx-fig="${key}"]`);

  function enableProps()  { propInputs.forEach(i => { i.disabled = false; }); }
  function disableProps() { propInputs.forEach(i => { i.disabled = true;  }); }

  function lockScroll(lock) {
    document.documentElement.classList.toggle('cmx-lock', lock);
    document.body.classList.toggle('cmx-lock', lock);
  }

  function revertToStandard() {
    tabs.forEach(t => t.classList.toggle('is-active', t.dataset.cmxMode === 'standard'));
    if (orderTypeProp) orderTypeProp.value = 'Standard';
    disableProps();
    if (noticeEl) noticeEl.hidden = true;
  }

  function openModal(showWarn) {
    modal.hidden = false;
    lockScroll(true);
    if (modalWarnEl) modalWarnEl.hidden = !showWarn;
    validate();
  }

  function closeModal() {
    modal.hidden = true;
    lockScroll(false);
    // If measurements incomplete, revert to Standard automatically
    if (addBtn && addBtn.disabled) {
      revertToStandard();
    }
  }

  /* Toggle mode */
  tabs.forEach(tab => {
    tab.addEventListener('click', () => {
      tabs.forEach(t => t.classList.remove('is-active'));
      tab.classList.add('is-active');

      if (tab.dataset.cmxMode === 'custom') {
        if (orderTypeProp) orderTypeProp.value = 'Custom';
        enableProps();
        if (noticeEl) noticeEl.hidden = false;
        openModal(false);
      } else {
        if (orderTypeProp) orderTypeProp.value = 'Standard';
        disableProps();
        if (noticeEl) noticeEl.hidden = true;
        closeModal();
      }
    });
  });

  closeBtns.forEach(btn => btn.addEventListener('click', (e) => { e.stopPropagation(); closeModal(); }));

  minusBtn?.addEventListener('click', () => {
    let v = parseInt(qtyInput?.value, 10) || 1;
    qtyInput.value = Math.max(1, v - 1);
  });

  plusBtn?.addEventListener('click', () => {
    let v = parseInt(qtyInput?.value, 10) || 1;
    qtyInput.value = v + 1;
  });

  unitBtns.forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.stopPropagation();
      unitBtns.forEach(b => b.classList.remove('is-active'));
      btn.classList.add('is-active');

      const u = (btn.dataset.cmxUnit || 'CM').toUpperCase();
      if (unitProp) unitProp.value = u;
      modal.querySelectorAll('[data-cmx-ulabel]').forEach(l => { l.textContent = u.toLowerCase(); });
      figUnits.forEach(el => { el.textContent = u.toLowerCase(); });
      validate();
    });
  });

  function validate() {
    const rangesCM = {
      bust:     { min: 50,  max: 150 },
      waist:    { min: 50,  max: 150 },
      hips:     { min: 50,  max: 150 },
      shoulder: { min: 20,  max: 50  },
      sleeve:   { min: 50,  max: 70  },
      stf:      { min: 120, max: 200 }
    };

    const unit = (unitProp?.value || 'CM').toUpperCase();
    const toIn = (cm) => +(cm / 2.54).toFixed(1);
    function getRange(key) {
      const r = rangesCM[key];
      if (!r) return null;
      return unit === 'IN' ? { min: toIn(r.min), max: toIn(r.max) } : r;
    }

    let valid = true;

    inputs.forEach(input => {
      const key = input.dataset.cmxInput;
      const val = parseFloat(input.value);

      const fig = figValues(key);
      if (fig) fig.textContent = isNaN(val) ? '–' : val;

      const prop = root.querySelector(`[data-cmx-prop="${key}"]`);
      if (prop) prop.value = isNaN(val) ? '' : String(val);

      const range  = getRange(key);
      const guideEl = modal.querySelector(`[data-cmx-guide="${key}"]`);
      if (guideEl && range) guideEl.textContent = `${range.min}–${range.max} ${unit.toLowerCase()}`;

      const errEl = modal.querySelector(`[data-cmx-err="${key}"]`);
      input.classList.remove('cmx-invalid');
      if (errEl) errEl.hidden = true;

      if (isNaN(val) || val <= 0) { valid = false; return; }

      if (range && (val < range.min || val > range.max)) {
        valid = false;
        input.classList.add('cmx-invalid');
        if (errEl) {
          errEl.textContent = `Allowed range: ${range.min}–${range.max} ${unit.toLowerCase()}`;
          errEl.hidden = false;
        }
      }
    });

    if (addBtn) {
      addBtn.disabled = !valid;
      addBtn.setAttribute('aria-disabled', String(!valid));
    }
    if (alertBox) alertBox.hidden = valid;
  }

  inputs.forEach(i => i.addEventListener('input', validate));

  /* Modal Add to Cart — measurements complete, close modal then fire the
     native .ajax_form_cart button so Basel's AJAX handler runs normally
     (cart drawer opens, user stays on page, no full-page redirect). */
  addBtn?.addEventListener('click', (e) => {
    e.stopPropagation();
    const form = root.closest('form');
    if (!form) return;

    // Sync modal qty → real quantity spinner
    const mainQty = form.querySelector('input[name="quantity"]:not([type="button"])');
    if (mainQty && qtyInput) mainQty.value = qtyInput.value || '1';

    // Close modal first
    modal.hidden = true;
    lockScroll(false);
    if (noticeEl) noticeEl.hidden = true;

    // Delay 50ms to break iOS ghost-tap: prevents the touch that closed
    // the modal from landing on BUY NOW (which is now at the same position).
    setTimeout(() => {
      const nativeAtc = form.querySelector('.ajax_form_cart');
      if (nativeAtc) {
        nativeAtc.click();
      } else {
        // Fallback: AJAX add directly
        const variantId = (form.querySelector('input[name="id"]') || form.querySelector('select[name="id"]'))?.value;
        if (!variantId) return;
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: parseInt(mainQty?.value) || 1 })
        }).then(() => { window.location.href = '/cart'; });
      }
    }, 50);
  });

  /* Intercept main ATC button: if Custom mode + incomplete → block and re-open modal */
  const form = root.closest('form');
  if (form) {
    form.addEventListener('submit', function(e) {
      if (orderTypeProp && orderTypeProp.value === 'Custom') {
        if (addBtn && addBtn.disabled) {
          e.preventDefault();
          e.stopImmediatePropagation();
          openModal(true); // true = show warning
        }
      }
    }, true); // capture phase
  }

  /* BUY NOW — adds item via Cart AJAX API then redirects to /checkout.
     Bypasses the theme's AJAX cart handler (which caused mobile home-page redirect). */
  const buyNowBtns = document.querySelectorAll('[data-cmx-buynow]');
  buyNowBtns.forEach(btn => {
    btn.addEventListener('click', function () {
      const f = root.closest('form');
      if (!f) return;

      // Custom mode + incomplete → open modal with warning instead
      if (orderTypeProp && orderTypeProp.value === 'Custom' && addBtn && addBtn.disabled) {
        openModal(true);
        return;
      }

      const variantId = (f.querySelector('input[name="id"]') || f.querySelector('select[name="id"]'))?.value;
      if (!variantId) return;

      const qty = parseInt(f.querySelector('input[name="quantity"]:not([type="button"])')?.value) || 1;

      // Collect active line item properties
      const properties = {};
      f.querySelectorAll('input[name^="properties["]').forEach(i => {
        if (!i.disabled && i.value.trim()) {
          const key = i.name.match(/\[(.+)\]/)?.[1];
          if (key) properties[key] = i.value.trim();
        }
      });

      const body = { id: variantId, quantity: qty };
      if (Object.keys(properties).length) body.properties = properties;

      // Loading state
      const origText = btn.textContent;
      btn.textContent = '...';
      btn.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body)
      })
      .then(r => {
        if (!r.ok) throw new Error('cart/add failed');
        window.location.href = '/checkout';
      })
      .catch(() => {
        btn.textContent = origText;
        btn.disabled = false;
      });
    });
  });

  /* Reset BUY NOW when browser restores page from bfcache (Back button).
     Without this, the button stays frozen as "..." after the user navigates
     to checkout and presses Back. */
  window.addEventListener('pageshow', (e) => {
    if (e.persisted) {
      buyNowBtns.forEach(btn => {
        btn.textContent = 'BUY NOW';
        btn.disabled = false;
      });
    }
  });

  // Init
  disableProps(); // Standard is default
  figUnits.forEach(el => (el.textContent = 'cm'));
  validate();

})();
